import { HelpAchieveGoals } from '@/page-content/individual-lessons/components/help-achieve-goals';
import { MainIndividualLessons } from '@/page-content/individual-lessons/components/main-individual-lessons';

import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { SERVICES_LIST } from '@/widgets/layouts/main/constants/services-list';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { Services } from '@/widgets/layouts/main/services';

import { PageSeo } from '@/shared/lib/seo';

import { PlusesIndividualLessons } from './components/pluses-individual-lessons';

export const IndividualLessonsPage = () => {
  return (
    <>
      <PageSeo
        title="Индивидуальные занятия"
        description="Индивидуальные занятия – кратчайший путь к достижению новых высот. Anglichannka – деловой английский для работы."
      />

      <MainIndividualLessons />

      <HelpAchieveGoals />

      <PlusesIndividualLessons />

      <Services servicesList={SERVICES_LIST} />

      <Reviews />

      <CallToAction withForm />
    </>
  );
};

IndividualLessonsPage.Layout = MainLayout;
